import instance from "../http";
import { getHeader } from "../../utils/utils";
import { summaryPrompt } from "../../constants/path";

export async function getSummaryPromptApi(perPage = 10, page = 1, search = "") {
  const headers = getHeader();
  const response = await instance.get(
    `${summaryPrompt.GET_SUMMARY_PROMPT}?page=${page}&perPage=${perPage}&search=${search}`,
    headers
  );
  return response;
}

export async function ViewSummaryTextApi(projectId, documentId) {
  const headers = getHeader();
  const response = await instance.get(
    summaryPrompt.GET_VIEW_SUMMARY_TEXT + projectId + "/" + documentId,
    headers
  );
  return response;
}

export async function createSummaryPromptApi(promptData) {
  const headers = getHeader();
  const response = await instance.post(
    summaryPrompt.CREATE_SUMMARY_PROMPT,
    promptData,
    headers
  );
  return response;
}

export async function showSummaryPromptApi(uuid) {
  const headers = getHeader();
  const response = await instance.get(
    summaryPrompt.SHOW_SUMMARY_PROMPT.replace(":uuid", uuid),
    headers
  );
  return response;
}

export async function updateSummaryPromptApi(uuid, promptData) {
  const headers = getHeader();
  const response = await instance.patch(
    summaryPrompt.UPDATE_SUMMARY_PROMPT.replace(":uuid", uuid),
    promptData,
    headers
  );
  return response;
}

export async function deleteSummaryPromptApi(uuid) {
  const headers = getHeader();
  const response = await instance.delete(
    summaryPrompt.DELETE_SUMMARY_PROMPT.replace(":uuid", uuid),
    headers
  );
  return response;
}

export async function bulkDeleteSummaryPromptApi(uuids) {
  const headers = getHeader();
  const response = await instance.post(
    summaryPrompt.BULK_DELETE_SUMMARY_PROMPT,
    { summary_prompt_uuids: uuids },
    headers
  );
  return response;
}

export async function activateSummaryPromptApi(uuid) {
  const headers = getHeader();
  const response = await instance.patch(
    summaryPrompt.ACTIVATE_SUMMARY_PROMPT.replace(":uuid", uuid),
    {},
    headers
  );
  return response;
}

export async function updateSummaryTextApi(projectId, documentId, summaryData) {
  const headers = getHeader();
  const response = await instance.patch(
    summaryPrompt.UPDATE_SUMMARY_TEXT + projectId + "/" + documentId,
    { summary_text: summaryData },
    headers
  );
  return response;
}

export async function regenerateSummaryPromptApi(projectId, documentId) {
  const headers = getHeader();
  const response = await instance.get(
    summaryPrompt.GET_REGENERATED_SUMMARY_PROMPT + projectId + "/" + documentId,
    headers
  );
  return response;
}
